import { useBreadcrumbsContext } from "./useBreadcrumbsContext.js";
import { useEffect, useMemo } from "react";
//#region src/components/Breadcrumbs/useSetBreadcrumbs.ts
var useSetBreadcrumbs = (breadcrumbs, dependencies = []) => {
	const { resetBreadcrumbs, setBreadcrumbs } = useBreadcrumbsContext();
	const _breadcrumbs = useMemo(() => breadcrumbs, dependencies);
	if (!setBreadcrumbs) console.warn("useSetBreadcrumbs() must be a descendant of <BreadcrumbsContextProvider />");
	useEffect(() => {
		if (setBreadcrumbs) setBreadcrumbs(_breadcrumbs);
		return resetBreadcrumbs;
	}, [dependencies]);
};
//#endregion
export { useSetBreadcrumbs };

//# sourceMappingURL=useSetBreadcrumbs.js.map